import { render, staticRenderFns } from "./ExaminationListPopup.vue?vue&type=template&id=045f0b60&scoped=true&"
import script from "./ExaminationListPopup.vue?vue&type=script&lang=js&"
export * from "./ExaminationListPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationListPopup.vue?vue&type=style&index=0&id=045f0b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f0b60",
  null
  
)

export default component.exports